<style>
  .dialog-resource-add-container {
    width: 100%;
    margin: 0 auto;
    @media (min-width: 800px) {
      padding: 20px 0;
      max-width: 600px;
    }
    &.small-dialog {
      max-width: 400px;
    }
  }
  .section-title-container {
     margin-bottom: 20px;
  }
  .section-title {
    display: flex;
    justify-content: space-between;
  }

  .v-tab {
    font-size: min(2.8vw, 14px);
    img {
      max-width: 60px;
      @media (min-width: 800px) {
        max-width: 84px;
      }
    }
  }
  .v-tab.v-tab--active {
    background-color: #dde7f1;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .v-tab:not(.v-tab--active) {
    color: #333!important;
    border-bottom: 2px solid #bbb;
  }

  .suggested-resources .v-list-item__action {
    margin: 5px 0;
  }

   [data-qa="dialog_resource_add__tabs"] .v-slide-group__prev {
     display: none !important;
   }

</style>

<template>
  <div
    class="dialog-resource-add-container"
    :class="getDynamicContainerStyle()"
  >
    <v-sheet
    elevation="2"
    style="position: relative; margin: 0 auto;"
  >
    <div class="section-settings-container__form">
      <div>
        <div>
          <v-tabs
            data-qa="dialog_resource_add__tabs"
            height="40"
            v-if="shouldShowTabs"
            v-model="tab"
            style="flex: 0; margin-bottom: 10px;"
            background-color="transparent"
            @change="onTabChange"
          >
            <v-tab v-if="showOpenAITab" style="text-transform: none; background-image: url(/img/openai-lockup.png); background-size: 84%; background-position: center;">
            </v-tab>
            <v-tab>{{ translate('ui_dialog_predefined') }}</v-tab>
            <v-tab>{{ translate('ui_dialog_custom') }}</v-tab>
          </v-tabs>
        </div>

        <v-window v-model="tab">
          <v-window-item v-if="showOpenAITab">
            <DialogResourceAddOpenAI
              v-if="section.isAddingResource"
              :section="section"
              :selectedResources="this.selectedResources"
              @updateSelectedResources="updateSelectedResources"
            />
          </v-window-item>
          <v-window-item>
            <DialogResourceAddPredefined
              v-if="section.isAddingResource"
              :predefinedResources="this.predefinedResources()"
              :selectedResources="this.selectedResources"
              @updateSelectedResources="updateSelectedResources"
            />
          </v-window-item>
          <v-window-item>
            <DialogResourceAddFinancingStep2
              v-if="section.id === 'section_financing'"
              :section="section"
              :dialogConfig="dialogConfig"
              :tabIndex="dialogResourceAddFinancingTabIndex"
              @onChangeFinancingType="onChangeFinancingType"
              :formulas="getFormulas()"
              :updateAssumptions="updateAssumptions"
            />
            <DialogResourceAddSimple
              v-if="shouldShowDialogSimple()"
              :dialogConfig="dialogConfig"
            />
            <DialogResourceAddStandard
              v-if="section.id !== 'section_financing' && !shouldShowDialogSimple()"
              :dialogConfig="dialogConfig"
              :formulas="getFormulas()"
              :dialogAssumptions="this.dialogAssumptions"
              :dialogUnits="this.dialogUnits"
              :onAssumptionsChange="this.onAssumptionsChange"
            />

          </v-window-item>
        </v-window>
        <v-divider></v-divider>

        <DialogToolbarBottom
          :resource="this.dialogConfig.resource"
          :section="section"
          :tab="tab"
          :dialogResourceAddFinancingTabIndex="dialogResourceAddFinancingTabIndex"
          :isSaveDisabled="isSaveDisabled"
          :onCancel="onCancel"
          :onSave="onSave"
          @onChangeStepDialogFinancing="onChangeStepDialogFinancing"
          :shouldHideCancelBtnFromParent="shouldHideCancelBtnFromParent"
        />
      </div>
    </div>
  </v-sheet>
  </div>
</template>

<script>

import DialogResourceAddStandard from '@/components/dialogs/DialogResourceAdd/DialogResourceAddStandard.vue';
import DialogResourceAddSimple from '@/components/dialogs/DialogResourceAdd/DialogResourceAddSimple.vue';
import DialogResourceAddFinancingStep2
  from '@/components/dialogs/DialogResourceAdd/DialogResourceAddFinancingStep2';
import DialogToolbarBottom from '@/components/dialogs/DialogToolbarBottom.vue';
import DialogResourceAddOpenAI from '@/components/dialogs/DialogResourceAdd/DialogResourceAddOpenAI.vue';
import DialogResourceAddPredefined from '@/components/dialogs/DialogResourceAdd/DialogResourceAddPredefined.vue';
import Mixin from '../../mixins/mixin';

export default {
  name: 'ResourceAddDialog',
  components: {
    DialogResourceAddFinancingStep2,
    DialogToolbarBottom,
    DialogResourceAddPredefined,
    DialogResourceAddOpenAI,
    DialogResourceAddStandard,
    DialogResourceAddSimple,
  },
  mixins: [Mixin],
  props: ['section', 'resource', 'shouldHideAITabFromParent', 'shouldHideCancelBtnFromParent'],
  data: () => ({
    tab: 0,
    dialogUnits: [],
    dialogAssumptions: [],
    selectedResources: [],
    selectedGroup: null,
    dialogConfig: {},
    simpleDialogSectionIds: ['section_currency', 'section_taxes', 'section_depreciation'],
    dialogResourceAddFinancingTabIndex: 1,
  }),
  mounted() {
    this.dialogConfig = this.getDialogConfig();
    this.dialogResourceAddFinancingTabIndex = this.section.isAddingResource ? 1 : 2;
    this.selectFirstInput(this.section.id);
    // if no resources display dialog
    if (this.section.sectionResources && !this.section.sectionResources.length) {
      const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
      this.$store.dispatch('updateState', {
        path: `activeTemplate.data.sections[${sectionIndex}].isAddingResource`,
        value: true,
      });
    }
    if (this.section.id === 'section_depreciation') {
      this.tab = 1;
    }
  },
  computed: {
    shouldShowTabs() {
      return !this.resource && this.section.id !== 'section_depreciation';
    },
    showOpenAITab() {
      // const allowedSections = this.$store.state.previewModules.reduce((arr, module) => {
      //   if (module?.templateSectionCfg?.isAIGenerationEnabled) {
      //     arr.push(module.templateSectionCfg.id);
      //   }
      //   return arr;
      // }, []);
      return this.$store.state.user.settings.allowOpenAI && this.section.isAIGenerationEnabled && !this.shouldHideAITabFromParent;
    },
    isSaveDisabled() {
      const noAISuggestedResourcesSelected = this.showOpenAITab && this.tab === 0;
      const noSuggestedResourcesSelected = (this.showOpenAITab && this.tab === 1) || this.tab === 0;
      const noResourcesSelected = noAISuggestedResourcesSelected || noSuggestedResourcesSelected;
      return this.section.isAddingResource && this.selectedResources.length === 0 && noResourcesSelected;
    },
    allowClone() {
      return this.resource && !this.resource.coreResource.isDefault;
    },
    allowDelete() {
      return this.resource && !this.resource.coreResource.isDefault;
    },
  },
  methods: {
    updateAssumptions(flowIndex, assumptionIndex, value) {
      this.onAssumptionsChange(flowIndex, assumptionIndex, value);
    },
    onTabChange() {
      this.selectedResources = [];
    },
    onChangeStepDialogFinancing(step) {
      this.dialogResourceAddFinancingTabIndex = step;
      const containerElement = this.$el.querySelectorAll('.v-stepper__wrapper')[1];
      setTimeout(() => {
        const input = containerElement.querySelector('input[type="text"]');
        input.focus();
        input.select();
      }, 300);
    },
    shouldShowDialogSimple() {
      if (!this.resource) return false;
      return this.simpleDialogSectionIds.includes(this.section.id);
    },
    onChangeFinancingType(value) {
      this.dialogConfig.resource.coreResource.rel = value;
    },
    getDynamicContainerStyle() {
      return this.simpleDialogSectionIds.includes(this.section.id) ? 'small-dialog' : '';
    },
    onCancel() {
      this.$emit('onCloseDialogResourceAdd');
    },
    updateSelectedResources(selectedResources) {
      this.selectedResources = selectedResources;
    },
    showStepTwo() {
      // TODO: need below?
      this.dialogResourceAddFinancingTabIndex = 2;
      this.tab = 2;
      const containerElement = this.$el.querySelectorAll('.v-stepper__wrapper')[1];
      setTimeout(() => {
        const input = containerElement.querySelector('input[type="text"]');
        input.focus();
        input.select();
      }, 100);
    },
    getDialogConfig() {
      let { resource } = this;
      if (!resource) {
        const resourceRel = this.section.coreResourceTypes[0];
        resource = this.createNewSectionResource(this.section, resourceRel);
      }
      const addResourceLabel = `${this.translate(this.section.addResourceLabel)}`;

      const formulas = this.getFormulas(resource);
      const title = resource ? `${this.translate('ui_dialog_edit')} ${resource.coreResource.name}`
        : `${this.translate('ui_add_btn')} ${addResourceLabel}`;

      if (this.resource) {
        this.tab = this.showOpenAITab ? 2 : 1;
      }

      const config = {
        title,
        formulas,
        section: this.section,
        resource,
        onScrollDisabled: false,
      };
      return config;
    },
    predefinedResourcesGroups() {
      return false;
    },
    predefinedResources() {
      const { section } = this;
      const { language } = this.$store.state.activeTemplate;
      const industry = this.predefinedResourcesGroups() ? this.predefinedResourcesGroups[this.selectedGroup].id : 'all';
      return this.$store.state.languages.predefined[language].filter(
        (r, index) => {
          // eslint-disable-next-line no-param-reassign
          const industryMatch = industry === 'all' || (r.industries && r.industries.includes(industry));
          const searchStringMatch = new RegExp(this.searchString, 'gi').test(r.name);
          // eslint-disable-next-line no-param-reassign
          r.id = index;
          const rRels = r.rel.split(',');
          const isRelAllowed = section.coreResourceTypes.some((coreResourceType) => rRels.includes(coreResourceType));
          return isRelAllowed && industryMatch && searchStringMatch;
        },
      ); // .sort((a, b) => (a.name > b.name ? 1 : -1));
    },
    addNewResource(selectedResource) {
      for (let count = 0; count < selectedResource.count; count++) {
        const { formula } = selectedResource;
        if (formula) {
          // check if the formula is already there in formulas
          const formulaExists = this.$store.state.activeTemplate.data.formulas.find((f) => f.id === formula.id);
          const canAddFormula = !['autodrawdown', 'autodrawdownloan'].includes(formula.id);
          if (!formulaExists && canAddFormula) {
            const { language } = this.$store.state.activeTemplate;
            formula.name = formula.name[language];
            formula.variables.forEach((variable) => {
              // eslint-disable-next-line
              variable.name = variable.name[language];
              if (typeof variable.units === 'object') {
                // eslint-disable-next-line
                variable.units = variable.units[language];
              }
              return variable;
            });
            // save formula in the template formulas
            const { formulas } = this.$store.state.activeTemplate.data;
            formulas.push(formula);
            this.$store.commit('updateState', {
              path: 'activeTemplate.data.formulas',
              value: formulas,
            });
          }
        }

        const { rel } = selectedResource;
        // eslint-disable-next-line
        const sectionResource = this.createNewSectionResource(this.section, rel, formula && formula.id);
        // replace default otherAssumptions if have them
        if (selectedResource.otherAssumptions) {
          Object.keys(sectionResource.otherAssumptions).forEach((otherAssumptionKey) => {
            if (selectedResource.otherAssumptions[otherAssumptionKey]) {
              sectionResource.otherAssumptions[otherAssumptionKey] = selectedResource.otherAssumptions[otherAssumptionKey];
            }
          });
        }
        const suffix = selectedResource.count > 1 ? ` ${count + 1}` : '';
        sectionResource.coreResource.name = `${selectedResource.name}${suffix}`;
        // save new coreResource
        const { coreResources } = this.$store.state.activeTemplate.data;
        coreResources.push(sectionResource.coreResource);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.coreResources',
          value: coreResources,
        });

        const { sectionResources } = this.$store.state.activeTemplate.data.divisions[0];
        sectionResources.push(sectionResource);
        console.log(sectionResource);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.divisions[0].sectionResources',
          value: sectionResources,
        });
      }
    },
    onSave(keepDialogOpen) {
      // TODO: refactor below
      const selectedSuggested = (this.showOpenAITab && this.tab < 2) || (!this.showOpenAITab && this.tab === 0);
      if (selectedSuggested) {
        const { selectedResources } = this;
        for (let i = 0; i < selectedResources.length; i++) {
          const selectedResource = selectedResources[i];
          if (selectedResource.bundle) {
            // add each resource in bundle
            selectedResource.bundle.forEach((bundleItem) => {
              // eslint-disable-next-line
              bundleItem.count = 1;
              this.addNewResource(bundleItem);
            });
          } else {
            this.addNewResource(selectedResource);
          }
        }
        // empty selections
        this.selectedResources = [];
      } else {
        this.saveResource(this.dialogConfig);
      }
      if (!keepDialogOpen) {
        if (this.section.id === 'section_depreciation') {
          const envSectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === 'section_environment');
          const deprSectionIndex = this.$store.state.activeTemplate.data.sections[envSectionIndex].sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
          this.$store.commit('updateState', {
            path: `activeTemplate.data.sections[${envSectionIndex}].sections[${deprSectionIndex}].isAddingResource`,
            value: false,
          });
        } else {
          const sectionIndex = this.$store.state.activeTemplate.data.sections.findIndex((sectionInState) => sectionInState.id === this.section.id);
          this.$store.commit('updateState', {
            path: `activeTemplate.data.sections[${sectionIndex}].isAddingResource`,
            value: false,
          });
        }
        this.saveSection(this.section);
        this.dialogConfig.resource = null;
        if (!this.$store.state.activeTemplate.isWizardEnabled) {
          // this.revealNextSection();
        }
      } else {
        const formulaId = this.dialogConfig.resource.flows[0].formula.id;
        const { resourceRel } = this.dialogConfig.resource.coreResource.rel;
        const newSectionResource = this.createNewSectionResource(this.section, resourceRel, formulaId);
        this.dialogConfig.resource = newSectionResource;
      }
    },
    deleteSectionResource(event) {
      const deleteMessage = `${this.translate('ui_confirm_delete')}: ${this.resource.coreResource.name}`;
      const confirm = window.confirm(deleteMessage);
      if (confirm) {
        this.deleteResource(event, this.resource);
      }
    },
    // cloneSectionResource(event) {
    //   this.cloneResource(event, this.section, this.resource);
    // },
  },
};
</script>
